import React, { useState } from "react";
import SiteWrapperSuperadminReact from "../SiteWrapper.superadmin.react";
import AddBlockedUsers from "./AddBlockedUsers";
import ViewBlockedUsers from "./ViewBlockedUsers";

export default function BlockedUsers() {
    const [refreshData, setRefreshData] = useState(0);
    return (
        <SiteWrapperSuperadminReact>
            <div className="container">
                <div className="row">
                    <div className="col-6">
                        <AddBlockedUsers onSubmit={() => setRefreshData((prev) => prev + 1)} />
                    </div>
                    <div className="col-6">
                        <ViewBlockedUsers refreshData={refreshData} />
                    </div>
                </div>
            </div>
        </SiteWrapperSuperadminReact>
    );
}
